import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1ed144da"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "user_name" };
export default /*#__PURE__*/ _defineComponent({
    props: {
        userName: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(props.userName), 1)
            ]));
        };
    }
});
